import { type InternalAxiosRequestConfig, type AxiosError } from 'axios'
import {
  GET_API_MICROSERVICE,
  GET_API_V5,
  GET_API_V6,
  LIST_MICROSERVICES,
  LOGGER_BASE_URL,
} from 'shared/config'
import { setTokenHeaderFromViaConfig } from 'entities/Auth/lib/setToken'

function isUrlIncludeKeyWord(url: string | undefined, keywords: string[]) {
  if (!url) {
    return false
  }
  const escapedKeywords = keywords.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  return RegExp(`(?:${escapedKeywords.join('|')})/`, 'i').test(url)
}

const mutationRequestConfig = (axiosConfig: InternalAxiosRequestConfig) => {
  setTokenHeaderFromViaConfig(axiosConfig)

  // Snapshot the reCAPTCHA action while it is still this request's own. The store is a singleton
  // shared by login, forgot and register, so reading it back when the response fails can pick up
  // whichever action a later flow set. Only set once, so a retry keeps the original.
  if (axiosConfig.reCaptchaStore && !axiosConfig.reCaptchaAction) {
    axiosConfig.reCaptchaAction = axiosConfig.reCaptchaStore.lastAction
  }

  const is_logger = axiosConfig?.url?.includes('logger/v1/logs') && LOGGER_BASE_URL
  const is_microservice = isUrlIncludeKeyWord(axiosConfig?.url, LIST_MICROSERVICES)

  axiosConfig.headers['External-Referer'] = window.location.href
  axiosConfig.baseURL = GET_API_V5()

  if (axiosConfig.apiVersion === 'v6') {
    axiosConfig.baseURL = GET_API_V6()
  }

  if (is_microservice && !is_logger) {
    axiosConfig.baseURL = GET_API_MICROSERVICE()
  }

  if (is_logger) {
    axiosConfig.baseURL = LOGGER_BASE_URL
  }

  return axiosConfig
}

export const interceptorsRequestSuccess = (config: InternalAxiosRequestConfig) => {
  return mutationRequestConfig(config)
}

export const interceptorsRequestError = (error: AxiosError) => {
  return Promise.reject(error)
}
